// District and Taluka data - same as mobile app
export const DISTRICTS = [
  { label: 'पुणे', value: 'pune' },
  { label: 'मुंबई', value: 'mumbai' },
  { label: 'नाशिक', value: 'nashik' },
  { label: 'औरंगाबाद', value: 'aurangabad' },
  { label: 'नागपूर', value: 'nagpur' },
  { label: 'ठाणे', value: 'thane' },
];

export const DISTRICT_TALUKA_MAP = {
  pune: [
    { label: 'पुणे शहर', value: 'pune_city' },
    { label: 'हवेली', value: 'haveli' },
    { label: 'मुळशी', value: 'mulshi' },
    { label: 'बारामती', value: 'baramati' },
    { label: 'मावळ', value: 'maval' },
    { label: 'शिरूर', value: 'shirur' },
    { label: 'दौंड', value: 'daund' },
    { label: 'इंदापूर', value: 'indapur' },
    { label: 'पुरंदर', value: 'purandar' },
    { label: 'वेल्हे', value: 'velhe' },
    { label: 'भोर', value: 'bhor' },
    { label: 'जुन्नर', value: 'junnar' },
    { label: 'आंबेगाव', value: 'ambegaon' },
    { label: 'खेड', value: 'khed' },
  ],
  mumbai: [
    { label: 'मुंबई शहर', value: 'mumbai_city' },
    { label: 'मुंबई उपनगर', value: 'mumbai_suburban' },
  ],
  nashik: [
    { label: 'नाशिक', value: 'nashik' },
    { label: 'सिन्नर', value: 'sinnar' },
    { label: 'दिंडोरी', value: 'dindori' },
    { label: 'इगतपुरी', value: 'igatpuri' },
    { label: 'पेठ', value: 'peth' },
    { label: 'येवला', value: 'yevla' },
    { label: 'बागलाण', value: 'baglan' },
    { label: 'सुरगाणा', value: 'surgana' },
    { label: 'कळवण', value: 'kalwan' },
    { label: 'देवळा', value: 'deola' },
    { label: 'चांदवड', value: 'chandwad' },
    { label: 'निफाड', value: 'niphad' },
    { label: 'त्र्यंबकेश्वर', value: 'trimbakeshwar' },
  ],
  aurangabad: [
    { label: 'औरंगाबाद', value: 'aurangabad' },
    { label: 'पैठण', value: 'paithan' },
    { label: 'गंगापूर', value: 'gangapur' },
    { label: 'फुलंब्री', value: 'phulambri' },
    { label: 'खुलताबाद', value: 'khultabad' },
    { label: 'वैजापूर', value: 'vaijapur' },
    { label: 'कन्नड', value: 'kannad' },
    { label: 'सोयगाव', value: 'soyagaon' },
    { label: 'सिल्लोड', value: 'sillod' },
  ],
  nagpur: [
    { label: 'नागपूर शहर', value: 'nagpur_city' },
    { label: 'नागपूर ग्रामीण', value: 'nagpur_rural' },
    { label: 'कामठी', value: 'kamptee' },
    { label: 'हिंगणा', value: 'hingna' },
    { label: 'सावनेर', value: 'savner' },
    { label: 'कलमेश्वर', value: 'kalmeshwar' },
    { label: 'भिवापूर', value: 'bhiwapur' },
    { label: 'मौदा', value: 'mouda' },
    { label: 'रामटेक', value: 'ramtek' },
    { label: 'उमरेड', value: 'umred' },
    { label: 'कुही', value: 'kuhi' },
    { label: 'परशिवनी', value: 'parseoni' },
    { label: 'नरखेड', value: 'narkhed' },
  ],
  thane: [
    { label: 'ठाणे', value: 'thane' },
    { label: 'कल्याण', value: 'kalyan' },
    { label: 'उल्हासनगर', value: 'ulhasnagar' },
    { label: 'अंबरनाथ', value: 'ambarnath' },
    { label: 'भिवंडी', value: 'bhiwandi' },
    { label: 'शहापूर', value: 'shahapur' },
    { label: 'मुरबाड', value: 'murbad' },
  ],
};
